import React, { useState } from "react";
import { observer } from "mobx-react";
import ReactEcharts from "echarts-for-react";
import CircularProgress from "@mui/material/CircularProgress";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";

const TaskAnalysisEChart = ({
  task,
  data,
  names,
  chartType,
  yTitle,
  xTitle,
  title,
  percentage,
}) => {
  const [loadingPrebaseline, setloadingPrebaseline] = useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setloadingPrebaseline(false);
  };
  const startDate =
    task.plannedStartDate === undefined || task.plannedStartDate === null
      ? new Date()
      : new Date(task.plannedStartDate);
  let months = [];
  let prebaselinedPeriods =
    task.plannedStartDate === undefined || task.plannedStartDate === null
      ? []
      : task.project.getUnarcPrebaselinePeriods(setloadingPrebaseline);

  const objects = data.map((x, index) => {
    return { name: names[index], data: x, type: chartType };
  });

  const axis = [];

  const monthDict = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const baselineXPos = [];
  months = task.plannedProgress.map((x, index) => {
    let mm = String(((startDate.getMonth() + index) % 12) + 1);
    let yyyy = startDate.getFullYear();

    if (mm === "12") {
      startDate.setYear(startDate.getFullYear() + 1);
    }
    let label = x.period + "\n(" + monthDict[mm] + " " + yyyy + ")";
    axis.push(label);

    if (prebaselinedPeriods !== undefined && prebaselinedPeriods !== null) {
      if (prebaselinedPeriods.includes(x.period)) {
        if (task.project.preBaselines) baselineXPos.push(label);
      }
    }

    let tooltip = "<br/>Date: " + monthDict[mm] + "/" + yyyy;

    return tooltip;
  });

  baselineXPos.forEach((label) => {
    objects.push({
      type: "line",
      name: "Baseline",
      stack: "top",
      markLine: {
        symbol: "none",
        label: {
          show: false,
        },
        lineStyle: {
          color: "grey",
          type: "solid",
          width: 3,
        },
        data: [
          {
            name: "Baseline",
            xAxis: label,
          },
        ],
      },
    });
  });

  const generateOverall = (componentIndex, dataIndex) => {
    let total = 0;
    data.forEach((element, pointer) => {
      if (pointer === componentIndex) {
        element.forEach((x, index) => {
          if (index <= dataIndex) {
            total += x;
          }
        });
      }
    });
    return Math.round(total);
  };

  const ToolTipGenerator = (param) => {
    return (
      name +
      param.seriesName +
      months[param.dataIndex] +
      toolTipMonth +
      dollars +
      Math.round(param.data) +
      percent +
      toolTipOverall +
      dollars +
      generateOverall(param.componentIndex, param.dataIndex) +
      percent
    );
  };

  const name = "Graph Name: ";
  const percent = percentage ? "%" : "";
  const dollars = percent ? "" : "$";
  const toolTipMonth = "<br/>" + yTitle + " this Month: ";
  const toolTipOverall = "<br/>Overall " + yTitle + ": ";

  const options = {
    title: {
      left: "center",
      text: title,
    },
    xAxis: {
      name: xTitle,
      data: axis,
    },
    yAxis: {
      name: yTitle,
    },
    dataZoom: [
      {
        bottom: "1.5%",
        type: "slider",
        xAxisIndex: 0,
        filterMode: "none",
      },
      {
        type: "slider",
        yAxisIndex: 0,
        filterMode: "none",
      },
      {
        type: "inside",
        xAxisIndex: 0,
        filterMode: "none",
      },
      {
        type: "inside",
        yAxisIndex: 0,
        filterMode: "none",
      },
    ],
    legend: {
      orient: "vertical",
      align: "right",
      bottom: "65%",
      right: "10%",
      borderWidth: 2,
      show: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        let Tooltip = "";
        params.forEach((param) => {
          Tooltip += "<br/>" + ToolTipGenerator(param) + "<br/>";
        });
        return Tooltip;
      },
    },
    series: objects,
  };

  return (
    <div>
      <ReactEcharts option={options} />
      <Snackbar
        title="Load PreBaseline Message"
        open={loadingPrebaseline}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          <div>
            <CircularProgress color="inherit" />
            Please wait while the baseline snapshot is being generated, this may
            take several minutes
          </div>
        </Alert>
      </Snackbar>
    </div>
  );
};

export default observer(TaskAnalysisEChart);
